import { _ as _objectSpread2 } from './objectSpread2-b7b195c3.esm.js';
import * as sizeTokens from '@hover/tokens-size';
import * as tokens$1 from '@hover/tokens-space';
import _pick from 'ramda/src/pick';
import _map from 'ramda/src/map';
import * as tokens from '@hover/tokens-typography';

var size$5 = [200, 300, 400, 500, 600];
var presets$1 = {
  200: {
    color: tokens.body200Color,
    fontFamily: tokens.body200Family,
    fontSize: tokens.body200Size,
    fontWeight: tokens.body200Weight,
    lineHeight: tokens.body200Height
  },
  300: {
    fontWeight: tokens.body300Weight,
    fontFamily: tokens.body300Family,
    color: tokens.body300Color,
    fontSize: tokens.body300Size,
    lineHeight: tokens.body300Height
  },
  400: {
    fontWeight: tokens.body400Weight,
    fontFamily: tokens.body400Family,
    color: tokens.body400Color,
    fontSize: tokens.body400Size,
    lineHeight: tokens.body400Height
  },
  500: {
    fontWeight: tokens.body500Weight,
    fontFamily: tokens.body500Family,
    color: tokens.body500Color,
    fontSize: tokens.body500Size,
    lineHeight: tokens.body500Height
  },
  600: {
    fontWeight: tokens.body600Weight,
    fontFamily: tokens.body600Family,
    color: tokens.body600Color,
    fontSize: tokens.body600Size,
    lineHeight: tokens.body600Height
  }
};
var sizes$3 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets$1);

var color = ['primary', 'success', 'warning', 'danger', 'neutral'];
var fill = ['solid', 'outline', 'minimal'];
var shapeEqual = ['circle', 'square'];
var shape = /*#__PURE__*/['pill', 'box'].concat(shapeEqual);
var size$4 = ['small', 'medium', 'default', 'large'];
var baseSizes = {
  small: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[400]), {}, {
    paddingLeft: tokens$1.size400,
    paddingRight: tokens$1.size400,
    height: sizeTokens.size200
  }),
  medium: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[500]), {}, {
    paddingLeft: tokens$1.size500,
    paddingRight: tokens$1.size500,
    height: sizeTokens.size300
  }),
  large: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[500]), {}, {
    paddingLeft: tokens$1.size600,
    paddingRight: tokens$1.size600,
    height: sizeTokens.size400
  })
};
var baseEqualSizes = {
  small: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[400]), {}, {
    height: sizeTokens.size200,
    width: sizeTokens.size200
  }),
  medium: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[500]), {}, {
    height: sizeTokens.size300,
    width: sizeTokens.size300
  }),
  large: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3[500]), {}, {
    height: sizeTokens.size400,
    width: sizeTokens.size400
  })
};
var sizes$2 = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, baseSizes), {}, {
  "default": baseSizes.medium
});
var equalSizes = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, baseEqualSizes), {}, {
  "default": baseEqualSizes.medium
});

var size$3 = ['default', 'small', 'medium', 'large'];

var size$2 = [200, 300, 400, 500, 600, 650, 700, 800, 900];
var presets = {
  200: {
    color: tokens.heading200Color,
    fontFamily: tokens.heading200Family,
    fontSize: tokens.heading200Size,
    fontWeight: tokens.heading200Weight,
    lineHeight: tokens.heading200Height,
    marginBottom: tokens.heading200Margin
  },
  300: {
    fontWeight: tokens.heading300Weight,
    fontFamily: tokens.heading300Family,
    color: tokens.heading300Color,
    fontSize: tokens.heading300Size,
    lineHeight: tokens.heading300Height,
    marginBottom: tokens.heading300Margin
  },
  400: {
    fontWeight: tokens.heading400Weight,
    color: tokens.heading400Color,
    fontFamily: tokens.heading400Family,
    fontSize: tokens.heading400Size,
    lineHeight: tokens.heading400Height,
    marginBottom: tokens.heading400Margin
  },
  500: {
    fontWeight: tokens.heading500Weight,
    color: tokens.heading500Color,
    fontFamily: tokens.heading500Family,
    fontSize: tokens.heading500Size,
    lineHeight: tokens.heading500Height,
    marginBottom: tokens.heading500Margin
  },
  600: {
    fontWeight: tokens.heading600Weight,
    color: tokens.heading600Color,
    fontFamily: tokens.heading600Family,
    fontSize: tokens.heading600Size,
    lineHeight: tokens.heading600Height,
    marginBottom: tokens.heading600Margin
  },

  /**
   * @deprecated use 600
   */
  650: {
    fontWeight: tokens.heading650Weight,
    color: tokens.heading650Color,
    fontFamily: tokens.heading650Family,
    fontSize: tokens.heading650Size,
    lineHeight: tokens.heading650Height,
    marginBottom: tokens.heading650Margin
  },
  700: {
    fontWeight: tokens.heading700Weight,
    color: tokens.heading700Color,
    fontFamily: tokens.heading700Family,
    fontSize: tokens.heading700Size,
    lineHeight: tokens.heading700Height,
    marginBottom: tokens.heading700Margin
  },
  800: {
    fontWeight: tokens.heading800Weight,
    color: tokens.heading800Color,
    fontFamily: tokens.heading800Family,
    fontSize: tokens.heading800Size,
    lineHeight: tokens.heading800Height,
    marginBottom: tokens.heading800Margin
  },
  900: {
    fontWeight: tokens.heading900Weight,
    color: tokens.heading900Color,
    fontFamily: tokens.heading900Family,
    fontSize: tokens.heading900Size,
    lineHeight: tokens.heading900Height,
    marginBottom: tokens.heading900Margin
  }
};
var displayPresets = {
  display200: {
    color: tokens.display200Color,
    fontFamily: tokens.display200Family,
    fontSize: tokens.display200Size,
    fontWeight: tokens.display200Weight,
    lineHeight: tokens.display200Height
  },
  display300: {
    fontWeight: tokens.display300Weight,
    fontFamily: tokens.display300Family,
    color: tokens.display300Color,
    fontSize: tokens.display300Size,
    lineHeight: tokens.display300Height
  },
  display400: {
    fontWeight: tokens.display400Weight,
    fontFamily: tokens.display400Family,
    color: tokens.display400Color,
    fontSize: tokens.display400Size,
    lineHeight: tokens.display400Height
  },
  display500: {
    fontWeight: tokens.display500Weight,
    fontFamily: tokens.display500Family,
    color: tokens.display500Color,
    fontSize: tokens.display500Size,
    lineHeight: tokens.display500Height
  },
  display600: {
    fontWeight: tokens.display600Weight,
    fontFamily: tokens.display600Family,
    color: tokens.display600Color,
    fontSize: tokens.display600Size,
    lineHeight: tokens.display600Height
  },
  display700: {
    fontWeight: tokens.display700Weight,
    fontFamily: tokens.display700Family,
    color: tokens.display700Color,
    fontSize: tokens.display700Size,
    lineHeight: tokens.display700Height
  },
  display800: {
    fontWeight: tokens.display800Weight,
    fontFamily: tokens.display800Family,
    color: tokens.display800Color,
    fontSize: tokens.display800Size,
    lineHeight: tokens.display800Height
  },
  display900: {
    fontWeight: tokens.display900Weight,
    fontFamily: tokens.display900Family,
    color: tokens.display900Color,
    fontSize: tokens.display900Size,
    lineHeight: tokens.display900Height
  }
};
var sizes$1 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets);
var displaySizes = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), displayPresets);

var size$1 = ['tiny', 'small', 'medium', 'default', 'large', 'huge'];
var sizes = {
  tiny: {
    width: sizeTokens.size75,
    height: sizeTokens.size75,
    margin: tokens$1.size50
  },
  small: {
    width: sizeTokens.size100,
    height: sizeTokens.size100,
    margin: tokens$1.size100
  },
  medium: {
    width: sizeTokens.size200,
    height: sizeTokens.size200,
    margin: tokens$1.size100
  },
  "default": {
    width: sizeTokens.size200,
    height: sizeTokens.size200,
    margin: tokens$1.size100
  },
  large: {
    width: sizeTokens.size300,
    height: sizeTokens.size300,
    margin: tokens$1.size200
  },
  huge: {
    width: sizeTokens.size400,
    height: sizeTokens.size400,
    margin: tokens$1.size300
  }
};

var size = ['default', 'small', 'medium', 'large'];

export { shapeEqual as a, size$4 as b, color as c, sizes$2 as d, equalSizes as e, fill as f, size$3 as g, size$2 as h, sizes$1 as i, displayPresets as j, displaySizes as k, sizes as l, size$1 as m, size as n, size$5 as o, presets as p, sizes$3 as q, presets$1 as r, shape as s };
